import { getLocalStorageByKey } from "../helpers/localstorage";

type HttpRequest<B> = {
    method: 'GET' | 'POST' | 'PUT' | 'DELETE';
    url: string;
    body?: B
}

type RequestConfig = {
    headers?: Record<string, string>;
    baseUrl?: string;
}

export const getBaseConfig = (): RequestConfig => {
    return {
        baseUrl: process.env.BASE_URL || window.location.origin,
        headers: {
            'Authorization': `${getLocalStorageByKey('USER_TOKEN')}`,
        }
    }
}


export const httpRequest = async <B, R>(request: HttpRequest<B>, config?: RequestConfig): Promise<R> => {
    const baseConfig = getBaseConfig();
    const url = config?.baseUrl ? `${config.baseUrl}/${request.url}` : `${baseConfig.baseUrl}/${request.url}`;
    let fetchConfig = {
        method: request.method,
        headers: {
            'Content-Type': 'application/json',
            ...baseConfig.headers, ...config?.headers ?? {},
        }
    }
    if (request.method !== 'GET') {
        fetchConfig = {...fetchConfig, body: JSON.stringify(request.body)}
    }
    return (await fetch(url, fetchConfig)).json();
}